const Joi = require("joi");

const loginSchema = (data) => {
  const schema = Joi.object({
    LoginId: Joi.string()
      .trim()
      // .pattern(new RegExp("^[a-zA-Z0-9]+$"))
      .required()
      .messages({
        "string.empty": "Please enter your ID.",
        "any.required": "Please enter your ID.",
      }),

    Pin: Joi.string()
      // .pattern(new RegExp("^[a-zA-Z0-9]+$"))
      .required()
      .messages({
        "string.empty": "Please enter your PIN.",
        "any.required": "Please enter your PIN.",
      }),

    // BrowserType: Joi.string().required().messages({
    //   "any.required": "Unable to get your browser type...",
    // }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = loginSchema;
